import { useQuery } from "@tanstack/react-query";

import { getAuditLogService } from "@/services/audit.service";
import { AuditListParams, AuditListResponse } from "@/types/audit.types";

export const auditQueryKeys = {
  all: () => ["audit"] as const,
  lists: () => [...auditQueryKeys.all(), "list"] as const,
  list: (params: AuditListParams) => [...auditQueryKeys.lists(), params] as const,
};

/** Returns `{pagination, filters, events}` — read `data?.events` for the rows. */
export const useGetAuditLog = (params: AuditListParams = {}) => {
  return useQuery<AuditListResponse, Error>({
    queryKey: auditQueryKeys.list(params),
    queryFn: () => getAuditLogService(params),
  });
};
